var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('swiper',{attrs:{"type":1}}),_c('home-about'),_c('home-brand'),_c('home-dynamic')],1)}
var staticRenderFns = []

export { render, staticRenderFns }